import { Col, ControlLabel, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import { CheckboxGroup, TextField } from '../../../../common/components/ReduxFormField';
import React from 'react';

export const Refund = ({ show, isRefund }) => {
  if (!show) {
    return null;
  }
  return (
    <Row>
      <Col sm={12} style={{ marginLeft: '-13px' }}>
        <Field
          currency
          labelSize={2}
          name="meta.refund"
          component={CheckboxGroup}
          options={[
            {
              label:
                'Refund - The refund will be processed using the original payment method. If you require the refund to be processed via a different payment method please un-tick this box and refer to accounts.\n',
              value: true,
            },
          ]}
        />
      </Col>
      {!isRefund && (
        <Row>
          <Col sm={12}>
            <div>
              <ControlLabel className="">Reason (lost card etc.) </ControlLabel>
              <Field type="textarea" component={TextField} name="meta.note.content" />
            </div>
          </Col>
        </Row>
      )}
    </Row>
  );
};
